export const companyTranslations = { 
  company: {
    profile: {
      ORGANIZATION_ADMIN: "Admin",
      ORGANIZATION_MEMBER: "Member"
    }
  }
}